import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=25e6e29c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e6e29c')) {
      api.createRecord('25e6e29c', component.options)
    } else {
      api.reload('25e6e29c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=25e6e29c&", function () {
      api.rerender('25e6e29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6rphBAVPYny/JS/comp/IncreaseNumber.vue"
export default component.exports